export default "__VITE_ASSET__nedC$rs4__"